import { Injectable } from '@angular/core';
import { ApiService } from '../../core/apiService';
import { Api } from '../../core/api';
import { RESOURCES } from '../../core/resources';
import { Card } from '../../model/card';
import { Observable } from 'rxjs/Observable';
import { Transaction } from '../../model/transaction';
import { CardNo } from '../../model/card-no';

@Injectable()
export class CardsService extends ApiService<Card> {

  current_page = 1;

  constructor(protected api: Api) {
    super(api);
    this.resource = RESOURCES.cards;
  }

  get page() {
    return this.current_page;
  }

  set page(p: number) {
    this.current_page = p;
  }

  transactions(card_id: number): Observable<Transaction[]> {
    return this.api.get(RESOURCES.card_transactions.replace(':card_id', card_id.toString()));
  }

  generateNumber(): Observable<CardNo> {
    return this.api.get(RESOURCES.card_no);
  }
  
  resetPin(card_id: number): Observable<any>{
	return this.api.put(RESOURCES.reset_pin.replace(':card_id', card_id.toString()), null);
  }
}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/resources/cards/cards.service.ts